import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { LANGUAGE_RESOLUTION } from "./helpers/language.helpers";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ...LANGUAGE_RESOLUTION,
    interpolation: {
      escapeValue: false,
    },
    ns: ["translation"],
  });

export default i18n;
